<template>
  <div class="support-page" :class="{ search: $route.path.includes('search') }">
    <Header />

    <div class="container">
      <template v-if="!index">
        <Breadcrumb v-if="breadcrumb.length" :breadcrumb="breadcrumb" classes="support" />
        <div class="row">
          <section class="col col-9 support-content">
            <slot name="primary-content" />
            <slot name="related-articles" />
          </section>
          <Topics class="col col-3 support-sidebar" keep-alive />
        </div>
      </template>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@itbpbg/lms-components/src/components/Breadcrumb';
import Header from './Header';
import Topics from './Topics';

export default {
  components: { Header, Topics, Breadcrumb },
  props: {
    index: { type: Boolean },
    breadcrumb: { type: Array, required: false, default: () => ([]) },
  },
};
</script>

<style lang="scss">
.support-page {
  padding-bottom: var(--spacing-md);
  background-color: var(--main-light-shade-1);

  .breadcrumb {
    margin: var(--spacing-32) 0;

    ul {
      li {
        span {
          color: var(--accent-shade-2);
        }
      }
    }

    &.support {
      ul li span {
        text-transform: unset;
      }
    }
  }

  .support-content {
    order: 1;
  }

  &.search .help-center-header {
    margin-bottom: var(--spacing-80);
  }

  .primary-content {
    border: 1px solid var(--main-light-shade-3);
    border-radius: 10px;
    padding: var(--spacing-80) var(--spacing-100);
    background-color: var(--main-light);

    h1 {
      font-size: 21px;
      line-height: 25px;
      margin: 0;
      margin-bottom: var(--spacing-32);
    }
  }

  @media (max-width: 768px) {
    .support-content {
      max-width: 100%;
      flex: 0 0 100%;

      .primary-content {
        padding: var(--spacing-md) var(--spacing-mdsm);
      }
    }
  }

  @include bp($bp-mobile) {
    padding-bottom: var(--spacing-80);

    .breadcrumb {
      margin: var(--spacing-80) 0 var(--spacing-32) 0;
    }
  }
}
</style>
